import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { db } from "./firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,

  onSnapshot,
  serverTimestamp,
  query,
  where,
  setDoc
} from "firebase/firestore";

import "./MenuView.css";
import "./MenuAsportoOpt.css";

const getCatId = (name) => String(name || "").toLowerCase().replace(/\s+/g, "-");

function MenuAsporto() {
  const { localeTag } = useParams();
  const normalizedLocaleTag = localeTag.toLowerCase().replace(/[^a-z0-9]/gi, "");
  
  // --- Stati principali ---
  const [infoLocale, setInfoLocale] = useState({});
  const [dishes, setDishes] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [ordineTemp, setOrdineTemp] = useState([]);
  const [note, setNote] = useState("");
  const [inputValues, setInputValues] = useState({});
  const [numeroOrdine, setNumeroOrdine] = useState(null);
  const [showRiepilogo, setShowRiepilogo] = useState(false);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ visible: false, message: "", type: "info" });
    const [banners, setBanners] = useState([]);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [bannersPromozionali, setBannersPromozionali] = useState([]);
  const [currentBannerPromoIndex, setCurrentBannerPromoIndex] = useState(0);
  
  const [showSponsor, setShowSponsor] = useState(false);
  const [currentSponsor, setCurrentSponsor] = useState(null);
  
  const [showPromozione, setShowPromozione] = useState(false);
  const [currentPromozione, setCurrentPromozione] = useState(null);

  // --- Nuovo stato per ordine corrente ---

  const [statoOrdine, setStatoOrdine] = useState("");
  const [statoOrdinePrecedente, setStatoOrdinePrecedente] = useState("");


  const [ordiniInviati, setOrdiniInviati] = useState([]);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [popupDish, setPopupDish] = useState(null);
  const sidebarRef = useRef(null);


  // --- Funzione per ottenere la descrizione tradotta ---
const getDescription = (dish) => dish.descrizione?.it || "";

  // --- Funzione snackbar ---
  const showSnack = (message, type = "info", duration = 3000) => {
    setSnackbar({ visible: true, message, type });
    setTimeout(() => setSnackbar({ visible: false, message: "", type: "info" }), duration);
  };

  // --- Fetch informazioni locale ---
  useEffect(() => {
    const ref = doc(db, "locali", normalizedLocaleTag);
    const unsubscribe = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        setInfoLocale(snap.data());
      }
    }, (error) => {
      console.error("Errore nel caricamento del locale:", error);
    });
    
    return () => unsubscribe();
  }, [normalizedLocaleTag]);

  // --- Fetch piatti ---
  useEffect(() => {
    const fetchDishes = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, "menu"), where("localeTag", "==", normalizedLocaleTag));
        const snapshot = await getDocs(q);
        const items = snapshot.docs
          .map((doc) => {
            const data = doc.data();
            // Gestisce nome e descrizione come oggetti multilingua o stringhe legacy
            const nomeObj = typeof data.nome === 'object' ? data.nome : { it: data.nome || "" };
            const descObj = typeof data.descrizione === 'object' ? data.descrizione : { it: data.descrizione || "" };
            
            return {
              id: doc.id,
              nome: nomeObj,
              descrizione: descObj,
              price: parseFloat(String(data.prezzo).replace(",", ".")) || 0,
              image: data.immagineUrl || "",
              category: data.categoria || "Altro",
              allergeni: data.allergeni || "",
              visibile: data.visibile !== false,
              inPromozione: data.inPromozione === true,
              ordine: data.ordine || 0
            };
          })
          .filter((item) => item.visibile);
        
        // Fetch categorie con ordine
        const categorieSnapshot = await getDocs(collection(db, "categorie"));
        const categorieList = categorieSnapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(cat => cat.localeTag === normalizedLocaleTag && cat.visibile !== false)
          .sort((a, b) => (a.ordine || 0) - (b.ordine || 0));
        
        setCategorie(categorieList);
        setDishes(items);
      } catch (error) {
        showSnack("Errore nel caricamento del menu", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchDishes();
  }, [normalizedLocaleTag]);

  // --- Fetch banner pubblicitari attivi ---
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const snapshot = await getDocs(collection(db, "banners"));
        const bannersAttivi = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(b => 
            b.localeTag?.toLowerCase() === normalizedLocaleTag.toLowerCase() && 
            b.attivo === true
          )
          .sort((a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0));
        setBanners(bannersAttivi);
      } catch (err) {
        console.error("Errore nel caricamento banner:", err);
      }
    };
    fetchBanners();
  }, [normalizedLocaleTag]);

  // --- Fetch banner promozionali attivi (gestori) ---
  useEffect(() => {
    const fetchBannersPromozionali = async () => {
      try {
        const snapshot = await getDocs(collection(db, "banners_promozionali"));
        const bannersAttivi = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(b => 
            b.localeTag?.toLowerCase() === normalizedLocaleTag.toLowerCase() && 
            b.attivo === true
          )
          .sort((a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0));
        setBannersPromozionali(bannersAttivi);
      } catch (err) {
        console.error("Errore nel caricamento banner promozionali:", err);
      }
    };
    fetchBannersPromozionali();
  }, [normalizedLocaleTag]);

  // --- Slideshow banner ogni 5 secondi ---
  useEffect(() => {
    if (banners.length <= 1) return;
    
    const interval = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [banners.length]);

  // --- Slideshow banner promozionali ogni 5 secondi ---
  useEffect(() => {
    if (bannersPromozionali.length <= 1) return;
    
    const interval = setInterval(() => {
      setCurrentBannerPromoIndex((prevIndex) => (prevIndex + 1) % bannersPromozionali.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [bannersPromozionali.length]);

  // --- Fetch sponsor popup attivi ---
  useEffect(() => {
    const fetchSponsor = async () => {
      try {
        const snapshot = await getDocs(collection(db, "sponsor"));
        const sponsorList = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(s => 
            s.localeTag?.toLowerCase() === normalizedLocaleTag.toLowerCase() && 
            s.attivo === true
          );
        
        
        if (sponsorList.length > 0) {
          setTimeout(() => {
            setCurrentSponsor(sponsorList[0]);
            setShowSponsor(true);
          }, 2000);
        }
      } catch (err) {
        console.error("Errore nel caricamento sponsor:", err);
      }
    };
    
    setShowSponsor(false);
    setCurrentSponsor(null);
    fetchSponsor();
  }, [normalizedLocaleTag]);

  // --- Fetch promozioni popup attive (gestori) ---
  useEffect(() => {
    const fetchPromozioni = async () => {
      try {
        const snapshot = await getDocs(collection(db, "promozioni"));
        const promozioniList = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(p => 
            p.localeTag?.toLowerCase() === normalizedLocaleTag.toLowerCase() && 
            p.attivo === true
          );
        
        
        if (promozioniList.length > 0) {
          setTimeout(() => {
            setCurrentPromozione(promozioniList[0]);
            setShowPromozione(true);
          }, 4000);
        }
      } catch (err) {
        console.error("Errore nel caricamento promozioni:", err);
      }
    };
    
    setShowPromozione(false);
    setCurrentPromozione(null);
    fetchPromozioni();
  }, [normalizedLocaleTag]);

  // --- Listener per ordine corrente (se esiste) ---
  useEffect(() => {
    if (!numeroOrdine) return;
    
    // Ascolta l'ordine nella collection principale "ordini" per lo stato in tempo reale
    const q = query(
      collection(db, "ordini"), 
      where("numeroOrdineAsporto", "==", numeroOrdine),
      where("locale", "==", normalizedLocaleTag)
    );
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        const ordineDoc = snapshot.docs[0];
        const data = ordineDoc.data();
        
        setStatoOrdine(data.stato || "inviato");
        
        // Sincronizza lo stato anche su ordini_asporto per consistenza
        const ordineAsportoRef = doc(db, "ordini_asporto", `${normalizedLocaleTag}_${numeroOrdine}`);
        setDoc(ordineAsportoRef, { stato: data.stato }, { merge: true }).catch(err => 
          console.error("Errore sincronizzazione stato:", err)
        );
      } else {
        
        setStatoOrdine("");
      }
    });
    
    return () => unsubscribe();
  }, [numeroOrdine, normalizedLocaleTag]);

  // --- Effetto sonoro quando lo stato cambia in "in preparazione" ---
  useEffect(() => {
    if (statoOrdinePrecedente && statoOrdinePrecedente !== "in preparazione" && statoOrdine === "in preparazione") {
      // Riproduci suono di notifica
      const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYIGWi68OScTgwPUKzn77hrHwU7k9nxxnksBSl8yPDbkUELElyx6OyrWBUJRp/i8bllHgYtfsz026ZLDBFcsOrrrl8XCkak5O+3ZiEEO5Xa8UVYDAsrYMX83LpfDAQydM722IEpBzWP2PPQgTUHJXbG8N2RQAoVXLPo7KpaFglHoOLyr2AdBSyCzvHYizYGGGm+7+Wh');
      audio.volume = 0.5;
      audio.play().catch(err => console.log("Errore riproduzione audio:", err));
    }
    
    // Suono diverso quando diventa "pronto"
    if (statoOrdinePrecedente && statoOrdinePrecedente !== "pronto" && statoOrdine === "pronto") {
      // Riproduci suono di successo (più allegro)
      const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYIGWi68OScTgwPUKzn77hrHwU7k9nxxnksBSl8yPDbkUELElyx6OyrWBUJRp/i8bllHgYtfsz026ZLDBFcsOrrrl8XCkak5O+3ZiEEO5Xa8UVYDAsrYMX83LpfDAQydM722IEpBzWP2PPQgTUHJXbG8N2RQAoVXLPo7KpaFglHoOLyr2AdBSyCzvHYizYGGGm+7+Wh');
      audio.volume = 0.7;
      audio.play().catch(err => console.log("Errore riproduzione audio:", err));
    }
    
    setStatoOrdinePrecedente(statoOrdine);
  }, [statoOrdine]);

  // --- Gestione input piatti ---
  const handleInputChange = (dishId, field, value) => {
    setInputValues((prev) => ({
      ...prev,
      [dishId]: {
        ...prev[dishId],
        [field]: value
      }
    }));
  };

const getDishName = (dish) => dish.nome?.it || "";

  // --- Aggiunta piatto carrello temporaneo locale (non in Firestore) ---
  const aggiungiItemTemp = (dish) => {
    const values = inputValues[dish.id] || { quantity: 1, custom: "" };
    const quantity = parseInt(values.quantity, 10) || 1;
    const custom = values.custom ? String(values.custom).trim() : "";

    if (!quantity || quantity < 1) return;

    setOrdineTemp((prev) => {
      const esistente = prev.find(
        (item) => item.dishId === dish.id && (item.custom || "") === custom
      );

      if (esistente) {
        return prev.map((item) =>
          item.dishId === dish.id && (item.custom || "") === custom
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      } else {
        return [
          ...prev,
{
  dishId: dish.id,
  name: getDishName(dish),
  category: dish.category || "",
  price: dish.price,
  quantity,
  custom,
  timestamp: new Date()
}
        ];
      }
    });

    setInputValues((prev) => ({ ...prev, [dish.id]: { quantity: 1, custom: "" } }));
    showSnack("✅ Aggiunto al carrello!", "success");
  };

  // --- Eliminazione item carrello ---
  const eliminaItemTemp = (itemToRemove) => {
    setOrdineTemp((prev) =>
      prev.filter(
        (item) =>
          !(item.dishId === itemToRemove.dishId && (item.custom || "") === (itemToRemove.custom || ""))
      )
    );
    showSnack("❎ Piatto rimosso", "info");
  };

  // --- Invio ordine con generazione numero progressivo ---
  const inviaOrdine = async () => {
    if (ordineTemp.length === 0) {
      return showSnack("⚠️ Nessun piatto selezionato", "error");
    }

    try {
      // Calcola totale
      let totale = ordineTemp.reduce((acc, it) => {
        return acc + (it.price * it.quantity);
      }, 0);
      totale = Math.round(totale * 100) / 100;

      // Riferimento al contatore ordini per questo locale
      const contatoreRef = doc(db, "contatori_ordini_asporto", normalizedLocaleTag);
      const contatoreSnap = await getDoc(contatoreRef);

      let nuovoNumero = 1;
      if (contatoreSnap.exists()) {
        nuovoNumero = (contatoreSnap.data().ultimoNumero || 0) + 1;
      }

      // Aggiorna contatore
      await setDoc(
        contatoreRef,
        { ultimoNumero: nuovoNumero },
        { merge: true }
      );

      // Crea ordine nella collection "ordini" (stessa delle altre dashboard)
      await addDoc(collection(db, "ordini"), {
        locale: normalizedLocaleTag,
        table: `ASPORTO-${nuovoNumero}`,
        chiaveTavolo: `${normalizedLocaleTag}_ASPORTO_${nuovoNumero}`,
        numeroOrdineAsporto: nuovoNumero,
        tipoOrdine: "ASPORTO",
        items: ordineTemp.map((it) => ({
  name: it.name,
  category: it.category || "",
  quantity: it.quantity,
  custom: it.custom || "",
  price: it.price
})),
        note,
        stato: "inviato",
vistoInCucina: false,
totale,
timestamp: serverTimestamp()
      });

      // Salva anche una copia in ordini_asporto per il tracking del cliente
      const ordineId = `${normalizedLocaleTag}_${nuovoNumero}`;
      await setDoc(doc(db, "ordini_asporto", ordineId), {
        locale: normalizedLocaleTag,
        numeroOrdine: nuovoNumero,
       items: ordineTemp.map((it) => ({
  name: it.name,
  category: it.category || "",
  quantity: it.quantity,
  custom: it.custom || "",
  price: it.price
})),
        note,
       stato: "inviato",
totale,
timestamp: serverTimestamp()
      });

      // Salva numero ordine in localStorage
      localStorage.setItem(`ordineAsporto_${normalizedLocaleTag}`, nuovoNumero.toString());
      setNumeroOrdine(nuovoNumero);

      // Reset
      setOrdineTemp([]);
      setNote("");
      setShowRiepilogo(false);
      showSnack("✅ Ordine inviato!", "success");
    } catch (error) {
      console.error("❌ Errore invio ordine:", error);
      showSnack("❌ Errore nell'invio dell'ordine", "error");
    }
  };

  // --- Carica numero ordine da localStorage all'avvio ---
  useEffect(() => {
    const savedNumero = localStorage.getItem(`ordineAsporto_${normalizedLocaleTag}`);
    if (savedNumero) {
      setNumeroOrdine(parseInt(savedNumero, 10));
    }
  }, [normalizedLocaleTag]);

  // --- Listener per ordini inviati (non ancora pagati) ---
  useEffect(() => {
    if (!numeroOrdine) return;
    
    const q = query(
      collection(db, "ordini"), 
      where("numeroOrdineAsporto", "==", numeroOrdine),
      where("locale", "==", normalizedLocaleTag)
    );
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const ordini = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(ordine => ordine.stato !== "pagamento" && ordine.stato !== "archiviato");
      setOrdiniInviati(ordini);
    });
    
    return () => unsubscribe();
  }, [numeroOrdine, normalizedLocaleTag]);

  const totalePiatti = ordineTemp.reduce((acc, item) => acc + (item.quantity || 0), 0);

  // --- Modalità scura/chiara automatica, identica al menu asporto ottimizzato ---
  useEffect(() => {
    try {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      const update = (event) => setIsDarkMode(event.matches);
      setIsDarkMode(mq.matches);

      if (mq.addEventListener) mq.addEventListener("change", update);
      else mq.addListener(update);

      return () => {
        if (mq.removeEventListener) mq.removeEventListener("change", update);
        else mq.removeListener(update);
      };
    } catch {
      setIsDarkMode(false);
    }
  }, []);

  // --- UI ---
  const bannerCorrente = bannersPromozionali.length > 0
    ? bannersPromozionali[currentBannerPromoIndex]
    : banners[currentBannerIndex];

  const PopupDish = () => {
    if (!popupDish) return null;

    const values = inputValues[popupDish.id] || { quantity: 1, custom: "" };
    const quantityNum = parseInt(values.quantity, 10) || 1;

    return (
      <div className="popup-overlay" onClick={() => setPopupDish(null)}>
        <div className="popup-content" onClick={(event) => event.stopPropagation()}>
          {popupDish.image && (
            <img src={popupDish.image} alt={getDishName(popupDish)} className="popup-image" />
          )}

          <div className="popup-info">
            <h2 className="popup-title">{getDishName(popupDish)}</h2>

            {getDescription(popupDish) && (
              <p className="popup-desc">{getDescription(popupDish)}</p>
            )}

            {popupDish.allergeni && (
              <div className="popup-allergens">
                <strong>Allergeni:</strong>
                <div className="popup-allergen-list">
                  {String(popupDish.allergeni)
                    .split(",")
                    .map((allergene) => allergene.trim())
                    .filter(Boolean)
                    .map((allergene) => (
                      <span key={allergene} className="popup-allergen-badge">{allergene}</span>
                    ))}
                </div>
              </div>
            )}

            <div className="popup-price">
              {(popupDish.price || 0).toFixed(2)} €
              {popupDish.inPromozione && <span className="promo-pill">🔥 Promo</span>}
            </div>

            {infoLocale.consentOrdine && (
              <>
                <div className="qty-controls" style={{ justifyContent: "center", marginBottom: "12px" }}>
                  <button
                    className="qty-btn"
                    onClick={() => {
                      if (quantityNum > 1) handleInputChange(popupDish.id, "quantity", quantityNum - 1);
                    }}
                  >
                    −
                  </button>
                  <span className="qty-number">{quantityNum}</span>
                  <button
                    className="qty-btn"
                    onClick={() => handleInputChange(popupDish.id, "quantity", quantityNum + 1)}
                  >
                    +
                  </button>
                </div>

                <input
                  className="popup-note-input"
                  type="text"
                  placeholder="Es. senza cipolla"
                  value={values.custom || ""}
                  onChange={(event) => handleInputChange(popupDish.id, "custom", event.target.value)}
                />

                <button
                  className="popup-add-btn"
                  onClick={() => {
                    aggiungiItemTemp(popupDish);
                    setPopupDish(null);
                  }}
                >
                  ➕ Aggiungi
                </button>
              </>
            )}

            <button className="popup-close-btn" onClick={() => setPopupDish(null)}>✕</button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`menu-root ${isDarkMode ? "dark" : "light"} menu-asporto-opt`}>
      <style>
        {`
          @keyframes preparingPulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: .78; transform: scale(1.015); }
          }
          @keyframes readyPulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: .82; transform: scale(1.02); }
          }
        `}
      </style>

      {/* TOPBAR */}
      <div className="categoria-nav">
        {infoLocale.logoUrl ? (
          <div className="nav-logo">
            <img src={infoLocale.logoUrl} alt={infoLocale.nome || "Logo locale"} />
          </div>
        ) : (
          <div className="nav-logo" />
        )}

        <div style={{ flex: 1 }} />

        {numeroOrdine && (
          <div
            style={{
              padding: "7px 11px",
              borderRadius: "10px",
              background: "rgba(255,255,255,0.08)",
              border: "1px solid rgba(255,255,255,0.12)",
              fontSize: "12px",
              fontWeight: 700,
              whiteSpace: "nowrap"
            }}
          >
            Ordine N° {numeroOrdine}
          </div>
        )}

        
      </div>

      <div className="top-spacer" />

      {/* STATO ORDINE */}
      {statoOrdine === "in preparazione" && (
        <div
          style={{
            margin: "10px 12px",
            padding: "13px",
            borderRadius: "12px",
            textAlign: "center",
            color: "#fff",
            fontWeight: 800,
            background: "linear-gradient(135deg, #ff8a00, #ff4d00)",
            animation: "preparingPulse 1.5s ease-in-out infinite"
          }}
        >
          🔥 IN PREPARAZIONE
        </div>
      )}

      {statoOrdine === "pronto" && (
        <div
          style={{
            margin: "10px 12px",
            padding: "14px",
            borderRadius: "12px",
            textAlign: "center",
            color: "#fff",
            fontWeight: 800,
            background: "linear-gradient(135deg, #43a047, #1b7f33)",
            animation: "readyPulse 1.2s ease-in-out infinite"
          }}
        >
          ✅ Ritira il tuo ordine!
        </div>
      )}

      {/* BANNER */}
      {bannerCorrente?.imageUrl && (
        <div
          className="mv-banner-wrapper"
          onClick={() => {
            if (bannerCorrente.link) window.open(bannerCorrente.link, "_blank", "noopener,noreferrer");
          }}
        >
          <img
            src={bannerCorrente.imageUrl}
            alt={bannerCorrente.titolo || "Banner"}
            className="mv-banner-image"
          />
          {bannerCorrente.titolo && (
            <div className="mv-banner-overlay">
              <span className="mv-banner-title">{bannerCorrente.titolo}</span>
            </div>
          )}
        </div>
      )}

      <div className="mv-shell">
        {/* CATEGORIE */}
        <aside className={`mv-sidebar ${infoLocale.menuConFoto === false ? "no-foto" : ""}`}>
          <div className="mv-sidebar-inner" ref={sidebarRef}>
            <button
              type="button"
              className={`mv-catbtn ${!activeCategory ? "active" : ""}`}
              onClick={() => {
                setActiveCategory(null);
                const main = document.querySelector(".mv-main");
                if (main) main.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <span className="mv-caticon">🍽️</span>
              <span className="mv-catlabel">Tutto</span>
            </button>

            {categorie.map((cat) => {
              const avatar = dishes.find((dish) => dish.category === cat.nome && dish.image)?.image;
              return (
                <button
                  key={cat.id}
                  type="button"
                  className={`mv-catbtn ${activeCategory === getCatId(cat.nome) ? "active" : ""}`}
                  onClick={() => {
                    setActiveCategory(getCatId(cat.nome));
                    const section = document.getElementById(`cat-${getCatId(cat.nome)}`);
                    const main = document.querySelector(".mv-main");
                    if (section && main) {
                      const sectionRect = section.getBoundingClientRect();
                      const mainRect = main.getBoundingClientRect();
                      main.scrollTo({
                        top: sectionRect.top - mainRect.top + main.scrollTop - 18,
                        behavior: "smooth"
                      });
                    }
                  }}
                >
                  {infoLocale.menuConFoto !== false && (
                    <span className="mv-caticon">
                      {avatar ? (
                        <img
                          src={avatar}
                          alt={cat.nome}
                          style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "16px" }}
                        />
                      ) : "🍽️"}
                    </span>
                  )}
                  <span className="mv-catlabel">{cat.nome}</span>
                </button>
              );
            })}
          </div>
        </aside>

        {/* CONTENUTO */}
        <main className="mv-main">
          {loading ? (
            <div className="menu-loading">
              <div className="spinner" />
              <p>Caricamento...</p>
            </div>
          ) : (
            <div className="mv-content">
              {categorie.map((cat) => (
                <section key={cat.id} className="mv-section">
                  <h3 id={`cat-${getCatId(cat.nome)}`} className="mv-section-title">{cat.nome}</h3>

                  <div className="mv-grid">
                    {dishes
                      .filter((dish) => dish.category === cat.nome)
                      .sort((a, b) => (a.ordine || 0) - (b.ordine || 0))
                      .map((dish) => {
                        const values = inputValues[dish.id] || {
  quantity: 1,
  custom: ""
};

const inCart = ordineTemp
                          .filter((item) => item.dishId === dish.id)
                          .reduce((sum, item) => sum + (item.quantity || 0), 0);
                        const conFoto = infoLocale.menuConFoto !== false;

                        return (
                          <div key={dish.id} className="mv-grid-item">
                            <div
                              className={`dish-card${conFoto ? "" : " no-foto"}`}
                              onClick={(event) => {
                                if (event.target.closest("input") || event.target.closest("button")) return;
                                setPopupDish(dish);
                              }}
                            >
                              {conFoto && (
                                <div className="dish-img-col">
                                  <div className="dish-image-wrapper">
                                    {dish.image ? (
                                      <img src={dish.image} alt={getDishName(dish)} className="dish-image" />
                                    ) : (
                                      <div className="dish-no-image">🍽️</div>
                                    )}
                                    {inCart > 0 && <div className="dish-badge-overlay">{inCart}</div>}
                                  </div>
                                  {dish.inPromozione && (
                                    <span className="promo-pill promo-pill--photo">🔥 Promo</span>
                                  )}
                                </div>
                              )}

                              <div className="dish-info-col">
                                <div className="dish-header-row">
                                  <span className="dish-name">{getDishName(dish)}</span>
                                  {!conFoto && inCart > 0 && <span className="dish-badge-inline">{inCart}</span>}
                                  <span className="dish-price">{(dish.price || 0).toFixed(2)} €</span>
                                </div>

                                {!conFoto && dish.inPromozione && <span className="promo-pill">🔥 Promo</span>}

                                {getDescription(dish) && <p className="dish-desc">{getDescription(dish)}</p>}



 {infoLocale.consentOrdine && (
  <div className="dish-action-row">
    <input
      type="text"
      className="note-input"
      placeholder="Es. senza cipolla"
      value={values.custom || ""}
      onChange={(event) =>
        handleInputChange(
          dish.id,
          "custom",
          event.target.value
        )
      }
    />

    <button
      type="button"
      className="add-btn"
      onClick={() => aggiungiItemTemp(dish)}
      aria-label="Aggiungi all'ordine"
    >
      +
    </button>
  </div>
)}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </section>
              ))}
            </div>
          )}
        </main>
      </div>

      {/* BOTTOM BAR */}
      <div className="bottom-bar">
        {infoLocale.consentOrdine && (
<button
  className="bottom-btn cart"
  onClick={() => setShowRiepilogo(true)}
>
  🛒 Riepilogo ordine ({totalePiatti})

  {totalePiatti > 0 && (
    <span className="bottom-cart-badge">
      {totalePiatti}
    </span>
  )}
</button>
        )}
      </div>
      <div className="bottom-spacer" />

      {/* RIEPILOGO */}
      {showRiepilogo && (
        <div className="sidebar">
          <div className="sidebar-header">
            <h3>🧾 Riepilogo ordine</h3>
            <button className="sidebar-close-btn" onClick={() => setShowRiepilogo(false)}>
              <span className="close-icon">×</span>
            </button>
          </div>

          <div className="sidebar-content">
            {ordiniInviati.length > 0 && (
              <div style={{ marginBottom: "20px" }}>
                <h4 style={{ marginBottom: "10px" }}>📋 Ordini inviati</h4>
                {ordiniInviati.map((ordine) => (
                  <div key={ordine.id} className="sent-order-block">
                    <strong>Ordine #{ordine.numeroOrdineAsporto} · {ordine.stato}</strong>
                    <div className="sent-order-items">
                      {ordine.items?.map((item, index) => (
                        <p key={index}>• {item.quantity}x {item.name}{item.custom ? ` (${item.custom})` : ""}</p>
                      ))}
                    </div>
                    <div style={{ marginTop: "6px", fontWeight: 700 }}>
                      Totale: €{(ordine.totale || 0).toFixed(2)}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <h4 style={{ marginBottom: "10px" }}>🛒 Nuovo ordine</h4>

            {ordineTemp.length === 0 ? (
              <p className="empty-msg">
  Nessun piatto aggiunto.
</p>
            ) : (
              ordineTemp.map((item, index) => (
  <div
    key={`${item.dishId}-${item.custom}-${index}`}
    className="cart-item-row"
  >
    <div className="cart-item-left">
      <strong>{item.name}</strong>

      {item.custom && (
        <p className="cart-item-note">
          📝 {item.custom}
        </p>
      )}
    </div>

    <div className="qty-controls">
      <button
        type="button"
        className="qty-btn"
        onClick={() => {
          if (item.quantity > 1) {
            setOrdineTemp((prev) =>
              prev.map((currentItem) =>
                currentItem.dishId === item.dishId &&
                (currentItem.custom || "") ===
                  (item.custom || "")
                  ? {
                      ...currentItem,
                      quantity: currentItem.quantity - 1
                    }
                  : currentItem
              )
            );
          } else {
            eliminaItemTemp(item);
          }
        }}
      >
        −
      </button>

      <span className="qty-number">
        {item.quantity}
      </span>

      <button
        type="button"
        className="qty-btn"
        onClick={() => {
          setOrdineTemp((prev) =>
            prev.map((currentItem) =>
              currentItem.dishId === item.dishId &&
              (currentItem.custom || "") ===
                (item.custom || "")
                ? {
                    ...currentItem,
                    quantity: currentItem.quantity + 1
                  }
                : currentItem
            )
          );
        }}
      >
        +
      </button>
    </div>
  </div>
))
            )}

            <textarea
              className="note-input"
              rows={3}
             placeholder="Es. allergie, preferenze..."
              value={note}
              onChange={(event) => setNote(event.target.value)}
              style={{ marginTop: "12px", width: "100%" }}
            />
          </div>

<div className="sidebar-actions">
  <button
    className="btn-send"
    onClick={inviaOrdine}
    disabled={!infoLocale.consentOrdine}
  >
    {infoLocale.consentOrdine
      ? "🚀 Invia ordine"
      : "🔒 Ordini non consentiti"}
  </button>

  <button
    className="btn-close-sidebar"
    onClick={() => setShowRiepilogo(false)}
  >
    ✖ Chiudi
  </button>
</div>
        </div>
      )}

      <PopupDish />

      {/* POPUP SPONSOR */}
      {showSponsor && currentSponsor && (
        <>
          <div className="popup-overlay" onClick={() => setShowSponsor(false)} />
          <div className="popup-card">
            <div className="ig-post-header">
              <div className="ig-avatar"><span>{(currentSponsor.titolo || "S").charAt(0)}</span></div>
              <div className="ig-meta">
                <span className="ig-username">{currentSponsor.titolo || "Sponsor"}</span>
                <span className="ig-sponsored">Sponsorizzato</span>
              </div>
              <button className="popup-close-btn" onClick={() => setShowSponsor(false)}>✕</button>
            </div>
            <div
              className="popup-img-wrapper"
              onClick={() => {
                if (currentSponsor.link) window.open(currentSponsor.link, "_blank", "noopener,noreferrer");
                setShowSponsor(false);
              }}
            >
              <img src={currentSponsor.imageUrl} alt={currentSponsor.titolo || "Sponsor"} />
            </div>
          </div>
        </>
      )}

      {/* POPUP PROMOZIONE */}
      {showPromozione && currentPromozione && (
        <>
          <div className="popup-overlay" onClick={() => setShowPromozione(false)} />
          <div className="popup-card">
            <div className="ig-post-header">
              <div className="ig-avatar ig-avatar--promo"><span>{(currentPromozione.titolo || "P").charAt(0)}</span></div>
              <div className="ig-meta">
                <span className="ig-username">{currentPromozione.titolo || "Promozione"}</span>
                <span className="ig-sponsored">🔥 Offerta speciale</span>
              </div>
              <button className="popup-close-btn" onClick={() => setShowPromozione(false)}>✕</button>
            </div>
            <div
              className="popup-img-wrapper"
              onClick={() => {
                if (currentPromozione.link) window.open(currentPromozione.link, "_blank", "noopener,noreferrer");
                setShowPromozione(false);
              }}
            >
              <img src={currentPromozione.imageUrl} alt={currentPromozione.titolo || "Promozione"} />
            </div>
          </div>
        </>
      )}

      {snackbar.visible && <div className="snackbar">{snackbar.message}</div>}
    </div>
  );
}

export default MenuAsporto;
